import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import * as CompetitionActions from '../actions/competitions.actions';
import { CompetitionsService } from '../../services/competitions.service';

@Injectable({ providedIn: 'root' })
export class CompetitionsEffects {
    private competitionsService = inject(CompetitionsService);
    private actions$ = inject(Actions);

    loadCompetitions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CompetitionActions.loadCompetitions),
            switchMap(() =>
                this.competitionsService.getCompetitions().pipe(
                    map(competitions => CompetitionActions.loadCompetitionsSuccess({ competitions })),
                    catchError(error => of(CompetitionActions.loadCompetitionsFailure({ error })))
                )
            )
        )
    );

    loadCompetitionsSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(CompetitionActions.loadCompetitionsSuccess),
                tap(({ competitions }) => {
                })
            ),
        { dispatch: false }
    );

    loadCompetitionsFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(CompetitionActions.loadCompetitionsFailure),
                tap(({ error }) => {
                })
            ),
        { dispatch: false }
    );
}